/**
 * Extracts an HTTP/HTTPS URL from a CSS background-image value.
 * Returns null for data: URLs, blob: URLs, or non-url() values.
 */
const extractHttpUrl = (backgroundImage: string): string | null => {
  const match = backgroundImage.match(/url\(["']?([^"')]+)["']?\)/);
  if (!match) return null;
  const url = match[1];
  return url.startsWith('data:') || url.startsWith('blob:') ? null : url;
};

export default extractHttpUrl;
